import * as React from "react";


export interface ICartContext {
  updateCartItem: (
    product: ShoppingCartItem,
    quantity: number
  ) => Promise<void>;
  selectAddress: () => void;
}

export const CartContext = React.createContext<ICartContext | undefined>(
  undefined
);
